import { Suspense } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/modules/auth/context/AuthProvider";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <Suspense fallback={<div className="min-h-screen bg-stone-100 text-stone-500 flex items-center justify-center">載入中...</div>}>
            <AppRoutes />
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
